export default {
  color: {
    primary: '195, 25, 36',
    light: '255, 255, 255',
    text: {
      primary: '17, 17, 17',
      secondary: '82, 82, 82'
    }
  },
  header: {
    height: '100px'
  },
  spacing: '1rem',
  clockSize: '400px'
}
